import React, { useState } from "react";
import Modal from "../shared/Modal";
import { PolicyProjectType } from "winslow-core";
import "./ModalCreatePolicyProject.css";
import { Selector } from "../common/Selector";
import { getPolicyProjectTypeLabel } from "winslow-core";
import PolicyStudioActionButton from "./components/PolicyStudioActionButton";

interface ModalCreatePolicyProjectProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (type: PolicyProjectType) => void;
}

const policyProjectTypeOptions = Object.values(PolicyProjectType)
  .map((type) => ({
    value: type,
    label: getPolicyProjectTypeLabel(type),
  }))
  .sort((a, b) => {
    return a.label.localeCompare(b.label);
  });

export const ModalCreatePolicyProject: React.FC<
  ModalCreatePolicyProjectProps
> = ({ isOpen, onClose, onSubmit }) => {
  const [selectedType, setSelectedType] = useState<PolicyProjectType | null>(
    null
  );

  const onChange = (value: string) => {
    setSelectedType(value as PolicyProjectType);
  };

  const handleSubmit = () => {
    if (selectedType) {
      onSubmit(selectedType);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        width: "500px",
      }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="modal-create-policy-project">
        <div className="modal-create-policy-project-title">
          <h2>Create New Policy Project</h2>
          <span style={{ color: "var(--text-color-secondary)" }}>
              Please select a policy type to create a new project.
            </span>
        </div>
        <div className="modal-create-policy-project-body">
          <div className="modal-create-policy-project-content">
            <Selector
              options={policyProjectTypeOptions}
              onChange={onChange}
              value={selectedType || ""}
              placeholder="Select a policy type"
            />
          </div>
        </div>
        <div className="modal-create-policy-project-buttons">
          <PolicyStudioActionButton
            label="Cancel"
            variant="primary"
            onClick={onClose}
          />
          <PolicyStudioActionButton
            label="Create Project"
            variant="tertiary"
            onClick={handleSubmit}
            disabled={!selectedType}
          />
        </div>
      </div>
    </Modal>
  );
};
